<template>
  <div class="d-flex bd-highlight flex-column">
    <div v-for="serviceGroup in serviceGroups" :key="serviceGroup.heading">
      <div class="flex mt-4 gap-1">
        <p>{{ serviceGroup.icon }}</p>
        <div class="mt-1">
          <h4 class="font-weight-bold mb-0 mt-0">
            {{ serviceGroup.heading }}
          </h4>
          <p class="mb-1 sub-heading">{{ serviceGroup.description }}</p>
        </div>
      </div>
      <div
        v-for="serviceId in serviceGroup.serviceIds"
        :key="serviceId"
        class="form-check ml-4"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :checked="value.find((v) => v.ServicesTypeId === serviceId).Selected"
          @change="
            updateSelection(
              value.find((v) => v.ServicesTypeId === serviceId),
              $event.target.checked
            )
          "
          :id="'choice_' + serviceId"
        />
        <label
          :for="'choice_' + serviceId"
          :id="'label_' + serviceId"
          class="form-check-label"
          >&nbsp;{{
            value.find((v) => v.ServicesTypeId === serviceId).FriendlyNames
          }}</label
        >
      </div>
    </div>
  </div>
</template>

<script>
const serviceGroups = [
  {
    heading: "Essential services",
    icon: "⭐",
    description:
      "Highly recommended for all overseas buyers — our Golden Three to have by your side",
    serviceIds: [4, 2, 8],
  },
  {
    heading: "Specialist services",
    icon: "🔑",
    description: "Often required depending on where and how you buy",
    serviceIds: [29, 28, 1],
  },
  {
    heading: "Additional services",
    icon: "➕",
    description: "Extra support for specific needs",
    serviceIds: [12, 26, 10, 30, 31],
  },
];

export default {
  name: "ServiceSelection",
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      serviceGroups,
    };
  },
  methods: {
    updateSelection(type, checked) {
      const updated = this.value.map((item) => {
        if (item.ServicesTypeId === type.ServicesTypeId) {
          return { ...item, Selected: checked };
        }
        return item;
      });
      this.$emit("input", updated);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.gap-1 {
  gap: 0.25rem;
}

.sub-heading {
  font-size: 14px;
  font-weight: 400;
  color: #666;
}
</style>
